import React, { Suspense } from "react";
import { Outlet, ScrollRestoration } from "react-router";

// Top of the route tree. ScrollRestoration scrolls new pages to the top and restores
// the position on back/forward; Suspense covers the lazily loaded pages.
const RootLayout: React.FC = () => (
  <>
    <ScrollRestoration />
    <Suspense
      fallback={
        <div className="flex min-h-[40vh] items-center justify-center text-sm text-muted-foreground">
          Loading page…
        </div>
      }
    >
      <Outlet />
    </Suspense>
  </>
);

export default RootLayout;
